// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"d6c97d35","902":"9757bfa5","979":"3e2b420f"}[chunkId] + ".chunk.js";
};